import FolderOutlined from '@mui/icons-material/FolderOutlined';
import PeopleOutline from '@mui/icons-material/PeopleOutline';
import { Box, Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { WarningCell } from 'v2/components/Warning/Warning';

interface Props {
  deviceGroupsCount: number;
  userGroupsCount: number;
}

export const DevicesAndUsersGroupsCell: React.FC<Props> = ({ deviceGroupsCount, userGroupsCount }) => {
  const { translation } = useTranslation();

  if (deviceGroupsCount === 0 && userGroupsCount === 0) {
    return <WarningCell label={translation.no_groups} />;
  }

  return (
    <Box height="100%" display="flex" alignItems="center">
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Stack direction="row" spacing={0.5} alignItems="center">
          <FolderOutlined sx={(theme) => ({ color: theme.palette.text.secondary })} />
          <Typography variant="caption">{deviceGroupsCount}</Typography>
        </Stack>
        <Stack direction="row" spacing={0.5} alignItems="center">
          <PeopleOutline sx={(theme) => ({ color: theme.palette.text.secondary })} />
          <Typography variant="caption">{userGroupsCount}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
